import { render, staticRenderFns } from "./LoadingWrapper.vue?vue&type=template&id=1a3ec6e8&functional=true&lang=pug&"
import script from "./LoadingWrapper.vue?vue&type=script&lang=js&"
export * from "./LoadingWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports